import { ReactNode } from 'react';
import { ErrorMessages } from './ErrorMessages';
import styles from './styles.module.scss';

type LabelType = 'required';

type Props = {
  /** フィールドのラベルのhtmlFor属性 */
  htmlFor: string;
  /** フィールドのラベルの種類 */
  labelType?: LabelType;
  /** フィールドのラベル */
  labelText: string;
  /** ラベルと入力フィールドの間に表示するメッセージ */
  beforeMessage?: ReactNode;
  /** フィールドの子要素 */
  children: ReactNode;
  /** エラーメッセージの配列 */
  errorMessages?: string[];
};

export const FieldWrapper: React.FC<Props> = ({
  htmlFor,
  labelType,
  labelText,
  beforeMessage,
  children,
  errorMessages,
}) => (
  <div className={styles.FieldWrapper}>
    <label htmlFor={htmlFor} className={styles.FieldWrapper__Label}>
      {labelText}
      {labelType === 'required' && <span className={styles.FieldWrapper__RequiredLabel}>必須</span>}
    </label>
    {beforeMessage && <span className={styles.FieldWrapper__BeforeMessage}>{beforeMessage}</span>}
    <div className={styles.FieldWrapper__ChildrenContainer}>{children}</div>
    {errorMessages && <ErrorMessages messages={errorMessages} />}
  </div>
);
